import { Link } from 'react-router-dom';
import { formatFullName, formatTitleCase, formatInitials } from 'shared/utils';
import { UserAvatar } from 'src/components/avatar';
import { colorPalette, ROUTES } from 'shared/constants';
import { ListItemsNavigator } from 'src/components/common/items-navigator';
import { NotFound } from 'src/components/common';
import styles from './case-detail.module.scss';

const AVATAR_COLORS = [
  colorPalette.primaryMain6,
  colorPalette.primaryMain7,
  colorPalette.primaryMain8,
  colorPalette.neutral6,
  colorPalette.neutral7,
];

function getParticipantInitials(participant) {
  const initials = formatInitials(participant);
  if (initials) return initials;
  return participant.externalUserName?.[0]?.toUpperCase() || '?';
}

export function CaseTeamColumn({ participants, lang }) {
  if (!participants?.length) {
    return (
      <div className={styles.column}>
        <div className={styles.columnHeader}>{lang.TAB_TEAM}</div>
        <NotFound text={lang.NO_DATA} />
      </div>
    );
  }

  return (
    <div className={styles.column}>
      <div className={styles.columnHeader}>{lang.TAB_TEAM}</div>
      <ListItemsNavigator className={styles.columnContent}>
        {participants.map((participant, index) => {
          const isExternal = !participant.email;
          const name = isExternal
            ? formatTitleCase(participant.externalUserName || '')
            : formatFullName(participant);
          const role = isExternal
            ? null
            : [participant.department, participant.role].filter(Boolean).join(', ');

          const content = (
            <>
              <UserAvatar
                user={participant}
                alt={getParticipantInitials(participant)}
                size="small"
                bgColor={AVATAR_COLORS[index % AVATAR_COLORS.length]}
              />
              <div className={styles.participantInfo}>
                <div className={styles.participantName}>{name}</div>
                {role && <div className={styles.participantRole}>{role}</div>}
              </div>
            </>
          );

          if (!isExternal && participant.id) {
            return (
              <Link
                key={participant.id}
                to={ROUTES.CONTACTS_PREVIEW.replace(':id', participant.id)}
                className={`${styles.participantRow} ${styles.participantLink}`}>
                {content}
              </Link>
            );
          }

          return (
            <div key={participant.externalUserName || index} className={styles.participantRow}>
              {content}
            </div>
          );
        })}
      </ListItemsNavigator>
    </div>
  );
}
